export const segmentedGraphStyles = {
    height: '400px !important',
    '@media screen and (max-width: 480px)': {
        height: '330px',
        'margin-left': '-10px',
        width: 'calc(100vw - 25px)',
    },
};
